import { uniqueId } from 'lodash';

const decodeKeys = {
  RecAreaID: 'id',
  OrgRecAreaID: 'orgRefId',
  ParentOrgID: 'orgId',
  RecAreaName: 'name',
  RecAreaDescription: 'description',
  RecAreaFeeDescription: 'feeDescription',
  RecAreaDirections: 'directions',
  RecAreaPhone: 'phone',
  RecAreaEmail: 'email',
  RecAreaReservationURL: 'reservationUrl',
  RecAreaMapURL: 'mapUrl',
  RecAreaLongitude: 'longitude',
  RecAreaLatitude: 'latitude',
  StayLimit: 'stayLimit',
  Keywords: 'keywords',
  Enabled: 'enabled',
  Reservable: 'reservable',
  LastUpdatedDate: 'lastUpdatedDate'
};
const encodeKeys = {
  id: 'recAreaID',
  orgId: 'orgID',
  orgRefId: 'legacyRecAreaIDOrg',
  name: 'recAreaName',
  description: 'recAreaDescription',
  feeDescription: 'recAreaFeeDescription',
  directions: 'recAreaDirections',
  phone: 'recAreaPhone',
  email: 'recAreaEmail',
  reservationUrl: 'recAreaReservationURL',
  mapUrl: 'recAreaMapURL',
  longitude: 'recAreaLongitude',
  latitude: 'recAreaLatitude',
  stayLimit: 'stayLimit',
  enabled: 'enabled',
  reservable: 'reservable',
  keywords: 'keywords'
};

// RecArea Facilities
function decodeFacilities(records) {
  return records.map((record) => ({
    _key: uniqueId('facility-'),
    id: record.FacilityID,
    name: record.FacilityName,
    link: record.ResourceLink
  }));
}

// RecAreaAddresses
const decodeAddressKeys = {
  RecAreaAddressID: 'id',
  RecAreaID: 'assetId',
  RecAreaAddressType: 'type',
  RecAreaStreetAddress1: 'address1',
  RecAreaStreetAddress2: 'address2',
  RecAreaStreetAddress3: 'address3',
  City: 'city',
  PostalCode: 'postalCode',
  AddressStateCode: 'stateCode',
  AddressCountryCode: 'countryCode',
  LastUpdatedDate: 'lastUpdatedDate'
};
const encodeAddressKeys = {
  id: 'recAreaAddressID',
  assetId: 'recAreaID',
  type: 'recAreaAddressType',
  address1: 'recAreaStreetAddress1',
  address2: 'recAreaStreetAddress2',
  address3: 'recAreaStreetAddress3',
  city: 'city',
  postalCode: 'postalCode',
  stateCode: 'addressStateCode',
  countryCode: 'addressCountryCode'
};

function decodeAddresses(records) {
  return records.map((record) => {
    const address = { _key: uniqueId('address-') };
    Object.keys(decodeAddressKeys).forEach((key) => address[decodeAddressKeys[key]] = record[key]);
    return address;
  });
}

export const encodeRecAreaAddress = (record) => {
  const address = {};
  Object.keys(encodeAddressKeys).forEach((key) => address[encodeAddressKeys[key]] = record[key]);
  return address;
};

// RecArea Activities
const decodeActivityKeys = {
  ActivityID: 'activityId',
  ActivityParentID: 'parentActivityId',
  RecAreaID: 'assetId',
  ActivityName: 'name',
  RecAreaActivityDescription: 'description',
  RecAreaActivityFeeDescription: 'feeDescription'
};
const encodeActivityKeys = {
  activityId: 'activityID',
  assetId: 'recAreaID'
};

function decodeActivities(records) {
  return records.map((record) => {
    const activity = { _key: uniqueId('activity-') };
    Object.keys(decodeActivityKeys).forEach((key) => activity[decodeActivityKeys[key]] = record[key]);
    return activity;
  });
}

export const encodeRecAreaActivity = (record) => {
  const activity = {};
  Object.keys(encodeActivityKeys).forEach((key) => activity[encodeActivityKeys[key]] = record[key]);
  return activity;
};

export const decodeRecArea = (record) => {
  const asset = { _key: uniqueId('asset-') };

  Object.keys(decodeKeys).forEach((key) => asset[decodeKeys[key]] = record[key]);

  asset.facilities = decodeFacilities(record.FACILITY);
  asset.addresses = decodeAddresses(record.RECAREAADDRESS);
  asset.activities = decodeActivities(record.ACTIVITY);

  return asset;
};

export const encodeRecArea = (record) => {
  const recArea = {};
  Object.keys(encodeKeys).forEach((key) => recArea[encodeKeys[key]] = record[key]);
  return recArea;
};
